import _extends from "@babel/runtime/helpers/extends";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import * as React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { DatePicker as MUIDatePicker } from '@mui/x-date-pickers/DatePicker';
import { TextField, useTheme } from '@mui/material';
import { dateGuard } from '../utils';
import { getLocaleBasedOnLanguage, useLocaleConfig } from '../../utils';
import makeClass from 'classnames';
var DatePicker = React.forwardRef(function (_ref, ref) {
  var _locale, _locale$toString;

  var disabled = _ref.disabled,
      dsOnChange = _ref.dsOnChange,
      dsOnClose = _ref.dsOnClose,
      dsOnBlur = _ref.dsOnBlur,
      locale = _ref.locale,
      language = _ref.language,
      dateAdapter = _ref.dateAdapter,
      e2e = _ref.e2e,
      error = _ref.error,
      format = _ref.format,
      fullWidth = _ref.fullWidth,
      helperText = _ref.helperText,
      label = _ref.label,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      value = _ref.value,
      required = _ref.required,
      readonly = _ref.readonly,
      placeholder = _ref.placeholder,
      views = _ref.views,
      setFormat = _ref.setFormat;
  var theme = useTheme();
  dateAdapter = dateAdapter || AdapterLuxon;
  var localeBasedOnLanguage = getLocaleBasedOnLanguage(language || theme.language);
  locale = locale || theme.locale;
  var localeConfig = useLocaleConfig();
  var localeData = localeConfig[((_locale = locale) === null || _locale === void 0 ? void 0 : (_locale$toString = _locale.toString()) === null || _locale$toString === void 0 ? void 0 : _locale$toString.replace('_', '-')) || 'en-US'];

  if (!format) {
    format = localeData === null || localeData === void 0 ? void 0 : localeData.format;
  }

  React.useEffect(function () {
    format && (setFormat === null || setFormat === void 0 ? void 0 : setFormat(format.toLowerCase()));
  }, [format, setFormat]);
  return /*#__PURE__*/React.createElement(LocalizationProvider, {
    locale: localeBasedOnLanguage,
    dateAdapter: dateAdapter
  }, /*#__PURE__*/React.createElement(MUIDatePicker, _extends({
    inputRef: ref,
    mask: localeData.mask,
    disabled: disabled,
    inputFormat: format,
    label: label,
    minDate: dateGuard(minDate),
    maxDate: dateGuard(maxDate),
    onChange: dsOnChange,
    onClose: dsOnClose,
    readOnly: readonly,
    value: value,
    views: views
  }, e2e && {
    'data-e2e': e2e,
    inputProps: {
      'data-e2e': "".concat(e2e, "-input")
    },
    InputLabelProps: {
      'data-e2e': "".concat(e2e, "-label")
    }
  }, {
    renderInput: function renderInput(params) {
      var _format;

      return /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
        className: makeClass({
          ReadOnly: readonly
        }),
        fullWidth: fullWidth,
        onBlur: dsOnBlur,
        error: error,
        required: required,
        helperText: helperText,
        variant: "outlined",
        inputProps: _objectSpread(_objectSpread({}, params.inputProps), {}, {
          placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : (_format = format) === null || _format === void 0 ? void 0 : _format.toLowerCase()
        })
      }));
    }
  })));
});
export default DatePicker;
//# sourceMappingURL=index.js.map